import api from "../../domain/api";
import {
  GET_LEADSTAGEAGEINGS,
  ADD_LEADSTAGEAGEING,
  EDIT_LEADSTAGEAGEING,
  GET_LEADSTAGEAGEING,
  RESET_LEADSTAGEAGEING,
  GET_ALL_LEADSTAGEAGEINGS,
  ERROR_LEADSTAGEAGEING,
} from "../types/leadstageageing_type";
import { handleError } from "../../shared/handleError";
import { setAlert } from "./alert";
export const addLeadstageageing = (formData) => async (dispatch, getState) => {
  try {
    const { data } = await api.post(`/leadstageageings`, formData);
    dispatch({
      type: ADD_LEADSTAGEAGEING,
      payload: data,
    });
  } catch (error) {
    dispatch(handleErrorLocal(error));
    dispatch(handleError(error));
  }
};
export const getLeadstageageings =
  ({
    termField = "",
    term = "",
    pageNumber = "",
    start_from = "",
    start_to = "",
  }) =>
  async (dispatch) => {
    try {
      dispatch({
        type: RESET_LEADSTAGEAGEING,
      });
      const { data } = await api.get(
        `/leadstageageings?searchTerm=${termField}&keyword=${term}&pageNumber=${pageNumber}&start_from=${start_from}&start_to=${start_to}`
      );

      dispatch({
        type: GET_LEADSTAGEAGEINGS,
        payload: data,
      });
    } catch (error) {
      dispatch(handleErrorLocal(error));
      dispatch(handleError(error));
    }
  };
export const getLeadstageageing = (id) => async (dispatch) => {
  try {
    dispatch({
      type: RESET_LEADSTAGEAGEING,
    });
    const { data } = await api.get(`/leadstageageings/${id}`);

    dispatch({
      type: GET_LEADSTAGEAGEING,
      payload: data,
    });
  } catch (error) {
    dispatch(handleErrorLocal(error));
    dispatch(handleError(error));
  }
};
export const editLeadstageageing = (id, formData) => async (dispatch) => {
  try {
    const { data } = await api.put(`/leadstageageings/${id}`, formData);
    dispatch({
      type: EDIT_LEADSTAGEAGEING,
      payload: data,
    });
  } catch (error) {
    dispatch(handleErrorLocal(error));
    dispatch(handleError(error));
  }
};
export const deleteLeadstageageing = (id) => async (dispatch) => {
  try {
    const { data } = await api.delete(`/leadstageageings/${id}`);
    dispatch(setAlert("Leadstageageing Deleted Successfully", "success"));
  } catch (error) {
    dispatch(handleErrorLocal(error));
    dispatch(handleError(error));
  }
};
export const getAllLeadstageageings = () => async (dispatch) => {
  try {
    const { data } = await api.get(`/leadstageageings/all`);

    dispatch({
      type: GET_ALL_LEADSTAGEAGEINGS,
      payload: data,
    });
  } catch (error) {
    dispatch(handleErrorLocal(error));
    dispatch(handleError(error));
  }
};

export const handleErrorLocal = () => async (dispatch) => {
  dispatch({ type: ERROR_LEADSTAGEAGEING });
};
